import { Component, OnInit } from '@angular/core';
import { UserService, PatientService, User, FormSessionCanDeactivate } from '../../shared';
import { ActivatedRoute, Resolve, Router, RouterStateSnapshot, RouterLink } from '@angular/router';
import { environment } from '../../shared/config/app-config';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
@Component({
  selector: 'app-profilesecurityquestion',
  templateUrl: './profilesecurityquestion.component.html',
  styleUrls: ['./profilesecurityquestion.component.css']
})
export class ProfilesecurityquestionComponent extends FormSessionCanDeactivate {

  dateformat: string;
  bsConfig: { containerClass: string; showWeekNumbers: boolean; dateInputFormat: any; };
  currentUser: any;
  imageURL: any;
  question: any = [];
  public selectques = [];
  public selectques1 = [];
  secQuestionOne: any = '';
  secQuestionThree: any = '';
  secQuestionTwo: any = '';
  secQusAnswerOne: any
  secQusAnswerThree: any
  secQusAnswerTwo: any
  public timealert = environment.timelimit;
  showloader: boolean;
  constructor(
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private router: Router,
    private toast: ToastrService,
    private Userservice: UserService
  ) {
    super();
  }

  ngOnInit() {
    this.Userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = true;
        if (this.currentUser.item) {
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
      });





    this.patientservice
      .getquestions()
      .subscribe(
        data => {
          if (data) {
            this.question = data;
          }
        }
      );
  }

  // getuniquelist(event){

  //   this.selectques = _.reject(this.question,(o:any):any=>{
  //    return o.userSecQuestionsId == event
  //    })
  //    ////console.log(this.selectques)
  //   }
  //   getlist(event){

  //     this.selectques1 = _.reject(this.selectques,(o:any):any=>{
  //      return o.userSecQuestionsId == event
  //      })

  //      ////console.log(this.selectques1)
  //       }

  logout() {
    // debugger
    //this.unRegister();
    /*    this.idleState = 'TIMED_OUT';
       this.timedOut = true; */

    /* if(this.status.reports){  */
    this.Userservice.logoutuser(this.currentUser.item.userAccountId)
    //this.progressBarPopup.close();
    /* } */
    this.Userservice.purgeAuth();
    //this.currentUser.status==false
    if (window.localStorage['plogin']) {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      //window.localStorage.clear()
      this.router.navigateByUrl('/plogin/' + plogin);

    } else {
      //this.currentUser.status==false
      //window.localStorage.clear()
      this.router.navigateByUrl('/login');
    }

    //this.resetTimeOut("init");


    /* this.idle.setAutoResume(AutoResume.notIdle);
    this.idle.watch() */
    /* alert(this.sessionService.getState());

    if(this.sessionService.getState() == "TIMED_OUT")
    { */
    // this.resetTimeOut("init");
    /*  } */

    //this.sessionService.setIdleObject(this.idle);

    //this.resetTimeOut();

    // this.resetTimeOut();


  }

  saveSecQuestion() {
    const obj = {
      secQuestionOne: this.secQuestionOne,
      secQuestionThree: this.secQuestionThree,
      secQuestionTwo: this.secQuestionTwo,
      secQusAnswerOne: this.secQusAnswerOne,
      secQusAnswerThree: this.secQusAnswerThree,
      secQusAnswerTwo: this.secQusAnswerTwo
    }

    this.Userservice.saveSecQuesAns(this.currentUser.item.userAccountId, obj)
      .subscribe(data => {
        this.showloader = true;
        if (data.status == "Success") {
          this.toast.success(this.Userservice.translateText('hospital_portal.disp_messages.question_saved.success'), '', {
            timeOut: this.timealert
          })
          this.Userservice.logAudit("saveSecQuesAns", 0).subscribe(data => { })
          this.Userservice.setAuth(this.currentUser);
        }
        else {
          this.toast.error(this.Userservice.translateText('patient_portal.display_messages.invalid_data.error'), '', {
            timeOut: this.timealert
          })
        }
      })
  }

  call() {
    alert(this.secQuestionOne)
  }

  getSecretQue() {
    this.Userservice.getSecQuesAns(this.currentUser.item.userAccountId)
      .subscribe(data => {
        if (data.secQuestionIdOne) {
          this.secQuestionOne = data.secQuestionIdOne
          this.secQuestionTwo = data.secQuestionIdTwo
          this.secQuestionThree = data.secQuestionIdThree
          this.secQusAnswerOne = data.secQusAnswerOne
          this.secQusAnswerTwo = data.secQusAnswerTwo
          this.secQusAnswerThree = data.secQusAnswerThree


          // //console.log("Edit Ques",data)
          this.getuniquelist(data.secQuestionIdOne, false)
          this.getlist(data.secQuestionIdTwo, false)
          this.getsecqueslist(data.secQuestionIdThree, false)
        }
      })
  }
  getuniquelist(event, enable) {

    this.selectques = _.reject(this.question, (o: any): any => {
      return o.userSecQuestionsId == event
    })
    if (enable) {
      if (event == this.secQuestionOne)
        this.secQusAnswerOne = ""
      if (event == this.secQuestionTwo) {
        this.secQuestionTwo = ""
        this.secQusAnswerTwo = ""
      }
      if (event == this.secQuestionThree) {
        this.secQuestionThree = ""
        this.secQusAnswerThree = ""
      }
    }
    ////console.log(this.selectques)
  }
  getlist(event, enable) {

    this.selectques1 = _.reject(this.selectques, (o: any): any => {
      return o.userSecQuestionsId == event
    })
    if (enable) {
      if (event == this.secQuestionOne) {
        this.secQuestionOne = ""
        this.secQusAnswerOne = ""
      }
      if (event == this.secQuestionTwo) {
        this.secQusAnswerTwo = ""
      }
      if (event == this.secQuestionThree) {
        this.secQuestionThree = ""
        this.secQusAnswerThree = ""
      }
    }
    ////console.log(this.selectques1)
  }
  getsecqueslist(event, enable) {
    if (enable) {
      if (event == this.secQuestionOne) {
        this.secQuestionOne = ""
        this.secQusAnswerOne = ""
      }
      if (event == this.secQuestionTwo) {
        this.secQuestionTwo = ""
        this.secQusAnswerTwo = ""
      }
      if (event == this.secQuestionThree) {
        this.secQusAnswerThree = ""
      }
    }
  }
}

